<template>
  <div class="kpi-ranking-page">
    <div class="img">
      <img src="https://j.weizan.cn/youxiang/images/rank_img.jpg" />
    </div>

    <div class="rank-flex">
      <div class="content">
        <div class="left-icon title person">
          <span>个人排行榜</span>
        </div>
        <div class="item" v-for="item in person" :key="item.type">
          <div @click="goPersonRank(item)">{{item.title}}</div>
        </div>
      </div>
      <div class="content">
        <div class="left-icon title brand">
          <span>品牌排行榜</span>
        </div>
        <div class="item" v-for="item in brand" :key="item.type">
          <div @click="goRank(item)">{{item.title}}</div>
        </div>
      </div>
    </div>

    <div class="ward">
      <h1>战区排行榜</h1>
      <div class="item" @click="goWard">战区分析</div>
    </div>

    <back-home
      :activity_id="activity_id"
      :user_id="user_id"
      :kpi_uid="kpi_userid"
      :share_uid="share_userid"
    ></back-home>

    <app-footer></app-footer>
  </div>
</template>

<script>
import appFooter from "../../components/app-footer";
import backHome from "../../components/back-home.vue";

export default {
  components: {
    backHome,
    appFooter,
  },
  data() {
    return {
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      contents: [],
      person: [],
      brand: [],
    };
  },
  created() {
    this.getContents();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    goWard () {
      this.$router.push({name: 'kpi.rankWard', query: {act_id: this.$route.query.act_id || localStorage.getItem("act_id")}})
    },
    // 获取排行内容
    getContents() {
      this.person = [
        // { type: 7, title: '自签单' },
        // { type: 9, title: '贡献签单' },
        // { type: 12, title: '点赞' },
        // { type: 16, title: '直播签单' },
        // { type: 18, title: '直播签单业绩' },
        // { type: 19, title: '转单数量' },
        // { type: 20, title: '转单金额' },
        { type: "view", title: "浏览" },
        { type: "fission", title: "裂变" }, // 转发
        { type: "enrollment", title: "报名" },
        { type: "card", title: "售券" },
        { type: "appointment", title: "直播预约" },
        { type: "live_view", title: "进入直播间" },
        { type: "live_order_cus", title: "直播下订" }, //客户
        { type: "bonus", title: "导购员奖励" },
        { type: "singleBonus", title: "单项奖励金" },
        { type: "score", title: "积分" },
        { type: "bean", title: "奖励豆" },
        { type: "thumb", title: "集赞" },
        { type: "seckill_user", title: "秒杀订单" },
        { type: "process_self_order", title: "过程自签单" },
        { type: "process_devote_order", title: "过程贡献单" },
        { type: "live_self_order", title: "直播自签订单" },
        { type: "live_other_order", title: "直播贡献订单" },
        { type: "act_sign", title: "签到" },
        { type: "live_self_order_change", title: "直播自签转单" },
        { type: "live_other_order_change", title: "直播贡献转单" },
      ];
      this.brand = [
        // { type: 7, title: '自签单' },
        // { type: 9, title: '贡献签单' },
        // { type: 17, title: '签单' },
        // { type: 155, title: '品牌阶段罚款', is_stage: true },
        // { type: 16, title: '品牌售卡签单率' },
        // { type: 18, title: '直播签单业绩' },
        // { type: 19, title: '转单数量' },
        // { type: 20, title: '转单金额' },
        { type: "view", title: "浏览" },
        { type: "fission", title: "裂变" },
        { type: "enrollment", title: "报名" },
        { type: "card", title: "售券" },
        { type: "appointment", title: "直播预约" },
        { type: "live_view", title: "进入直播间" },
        { type: "live_order_cus", title: "直播下订" },
        { type: "bonus", title: "导购员奖励" },
        { type: "singleBonus", title: "单项奖励金" },
        { type: "score", title: "积分" },
        { type: "bean", title: "奖励豆" },
        { type: "thumb", title: "集赞" },
        { type: "seckill_user", title: "秒杀订单" },
        { type: "order_sign_num", title: "直播签单" },
        { type: "process_self_order", title: "过程自签单" },
        { type: "process_devote_order", title: "过程贡献单" },
        { type: "live_self_order", title: "直播自签订单" },
        { type: "live_other_order", title: "直播贡献订单" },
        { type: "act_sign", title: "签到" },
        { type: "live_self_order_change", title: "直播自签转单" },
        { type: "live_other_order_change", title: "直播贡献转单" },
        { type: "hand_naam", title: "品牌罚款" },
      ];
    },
    goPersonRank(item) {
      switch (item.type) {
        case "view":
        case "fission":
        case "act_sign":
        case "thumb":
        case "appointment":
        case "live_view":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "次",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "card":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "张",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "seckill_user":
        case "process_self_order":
        case "process_devote_order":
        case "live_self_order":
        case "live_other_order":
        case "live_self_order_change":
        case "live_other_order_change":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "单",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "score":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "分",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "enrollment":
        case "live_order_cus":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "人",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "bean":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "个",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "singleBonus":
        case "bonus":
          this.$router.push({
            name: "kpi.rank.person",
            query: {
              title: item.title,
              type: item.type,
              unit: "元",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
      }
    },
    goRank(item) {
      switch (item.type) {
        case "view":
        case "fission":
        case "act_sign":
        case "thumb":
        case "appointment":
        case "live_view":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "次",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "card":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "张",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "seckill_user":
        case "process_self_order":
        case "process_devote_order":
        case "live_self_order":
        case "live_other_order":
        case "live_self_order_change":
        case "live_other_order_change":
        case "order_sign_num":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "单",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "score":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "分",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "enrollment":
        case "live_order_cus":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "人",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "bean":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "个",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
        case "singleBonus":
        case "bonus":
        case "hand_naam":
          this.$router.push({
            name: "kpi.rank.brand",
            query: {
              title: item.title,
              type: item.type,
              unit: "元",
              act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
          return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-ranking-page {
  padding-bottom: 50px;
  background: rgba(0, 0, 0, 0.03);
  .img {
    height: 100px;
    padding: 10px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: bottom;
      border-radius: 6px;
    }
  }
  .rank-flex {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin-bottom: 10px;
    .content {
      flex: 1;
      overflow: hidden;
      margin: 0 10px;
      background-color: #ffffff;
      padding: 10px;
      text-align: center;
      color: #3283fa;
      .title {
        line-height: 30px;
      }
      .brand {
        span::before {
          background-image: url("https://j.weizan.cn/youxiang/images/brand_icon.png");
        }
      }
      .person {
        span::before {
          background-image: url("https://j.weizan.cn/youxiang/images/person_icon.png");
        }
      }
      .item {
        color: #323232;
        background-color: #e2f1ff;
        padding: 10px;
        margin-top: 10px;
      }
    }
  }
  .ward {
    background-color: #ffffff;
    text-align: center;
    margin: 0 10px 10px;
    padding: 15px 15px 20px;
    font-size: 14px;
    h1 {
      font-weight: 700;
    }
    .item {
      color: #323232;
      background-color: #e2f1ff;
      padding: 10px;
      margin-top: 10px;
    }
  }
  .left-icon {
    color: #5293fd;
    text-align: center;
    position: relative;
    left: 10px;
    span {
      position: relative;
    }
    span::before {
      content: " ";
      position: absolute;
      background-size: 20px 20px;
      width: 20px;
      height: 20px;
      left: -24px;
      top: -3px;
    }
  }
  .brand {
    span::before {
      content: " ";
      background-size: 19px 17px;
      width: 19px;
      height: 17px;
      top: -1px;
    }
  }
}
</style>
